import { render, staticRenderFns } from "./AddBankCommodity.vue?vue&type=template&id=2710cc52&"
import script from "./AddBankCommodity.vue?vue&type=script&lang=js&"
export * from "./AddBankCommodity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports